import { em } from 'polished'
import styled from 'styled-components'

import Icon from 'components/Icon'
import SectionWrapper from 'components/SectionWrapper'

const imageBlockSize = '66.66667%'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: self-start;
  justify-items: flex-start;
`

export const Box = styled.img`
  flex: 0 0 ${imageBlockSize};
  width: ${imageBlockSize};
  height: auto;
`

export const Descriptions = styled.div`
  flex: 1 0 auto;
`

export const Info = styled.div`
  position: relative;
  max-width: ${em(196)};
  transform: translateY(-100%);
`

export const IconWrapper = styled.div`
  position: absolute;
  transform: translateX(-100%);
`

export const IconStyled = styled(Icon)`
  width: ${em(20)};
  height: ${em(30)};
`

export const Line = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
  height: 1px;
  background: ${p => p.theme.colors.whiteOp1};
`

export const SectionWrapperStyled = styled(SectionWrapper)`
  background-color: ${p => p.theme.colors.mineShaft};
`
